import { t } from '@lingui/macro';

import track from '~/mixpanel-service';
import { SelectableAccount } from '~/types';
import { tBB } from '~/app/shared/components/l10n/l10n';
import { SmartPayIntegrationError, smartPayValidAccountTypes } from '../../../types';

export const getCompleteAccountNumber = (bankRegistrationNumber: string, bankAccountNumber: string) => {
    const initialString = `${bankRegistrationNumber ?? ''}${bankAccountNumber ?? ''}`;

    if ([11, 14].includes(initialString.length)) return initialString;

    const bankAccountNoLength = initialString.length < 11 ? 7 : 10;

    return `${initialString.slice(0, 4).padEnd(4, '0')}${initialString.slice(4).padStart(bankAccountNoLength, '0')}`;
};

export const mapFeeAccountsByAccountNumber = feeAccounts => {
    const result: Map<number, SelectableAccount> = new Map<number, SelectableAccount>();
    feeAccounts.forEach(f => {
        result.set(f.number, f);
    });

    return result;
};

export const isValidBankOrFeeAccount = (accountId, bankAccountsMap) => {
    const selectedAccount = bankAccountsMap.get(accountId || 0);
    return !selectedAccount || smartPayValidAccountTypes.includes(selectedAccount.type.number);
};

export const sanitizeCVRNumber = (cvr: string) => {
    if (cvr.match(/^([dD][kK])(?:\d{8})$/) !== null) {
        // remove country code from the CVR
        const regex = /^([dD][kK])/;
        return cvr.replace(regex, '');
    }

    if (cvr.match(/^(\d{8})$/) !== null) return cvr;

    return null;
};

export const trackSmartPaySignupError = (error: any) => {
    if (!error) return;

    let eventSlug = 'signup.modal.error-generic';

    switch (error) {
        case SmartPayIntegrationError.SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_ACCOUNT_NUMBER_LENGTH_INVALID:
            eventSlug = 'signup.modal.error-bankaccount-length';
            break;
        case SmartPayIntegrationError.SMARTPAY_ONBOARDING_MODAL_ERROR_STATE_BANK_NOT_SUPPORTED:
            eventSlug = 'signup.modal.error-bank-notsupported';
            break;
        case SmartPayIntegrationError.NEWSLETTER_SUBSCRIBE:
            eventSlug = 'signup.modal.error-newsletter-subscribe';
            break;
    }

    // TODO replace tbb with t when old signup is removed
    track('smartpay', eventSlug, { errorMessage: tBB(error) });
};

export const getOnboardingErrorMessage = (errorCode: string): string => {
    switch (errorCode) {
        case 'This Cvr has already been registered for an agreement.':
            return t`This CVR has already been registered for an agreement.`;
        case 'Another integration has already been started for this cvr.':
            return t`Another integration has already been started for this CVR.`;
        case 'Error creating integration with NovemberFirst.':
            return t`Error creating integration with November First.`;
        default:
            return '';
    }
};
